import { Injectable } from '@angular/core';
import { Client, IMessage } from "@stomp/stompjs";
import { Observable, Subject } from 'rxjs';
import { environment, RABBIT_CONFIG } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WebsocketService {
  private client: Client;
  private messageSubject = new Subject<any>();
  public connected = false;

  constructor() {
    this.client = new Client({
      brokerURL: environment.API.rabbitAddress,
      reconnectDelay: 5000,
      connectHeaders: {
        login: RABBIT_CONFIG.USER,
        passcode: RABBIT_CONFIG.PASSWD
      }
    });
   }

  connect(referenceId: string) : void {
    this.client.onConnect = () => {
      // this.client.subscribe(`/exchange/anonymous_payments/${referenceId}`,
      //   (message: IMessage) => this.messageSubject.next(message.body),
      //   {id: referenceId}
      // )
      this.connected = true;
      this.client.subscribe(`anonym-${referenceId}`,
        (message: IMessage) => this.messageSubject.next(message.body),
        {id: referenceId}
      )
    }
    this.client.activate();
  }

  get message$(): Observable<any> {
    return this.messageSubject.asObservable();
  }

  disconnect(): void {
    this.client.deactivate().then(() => {
      this.connected = false;
    });
  }
}
